import React, { useEffect } from 'react';

const ParticleBackground = () => {
  useEffect(() => {
    // 创建粒子
    const createParticle = () => {
      const particle = document.createElement('div');
      particle.className = 'particle';
      particle.style.left = Math.random() * window.innerWidth + 'px';
      particle.style.animationDuration = (Math.random() * 20 + 10) + 's';
      particle.style.animationDelay = Math.random() * 5 + 's';
      document.getElementById('particle-container').appendChild(particle);
      
      // 动画结束后移除粒子
      setTimeout(() => {
        particle.remove();
      }, 30000);
    };

    // 创建初始粒子
    for (let i = 0; i < 20; i++) {
      setTimeout(() => createParticle(), i * 300);
    }

    // 定期创建新粒子
    const interval = setInterval(createParticle, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div id="particle-container" className="particle-container"></div>
      <div className="scan-line"></div>
    </>
  );
};

export default ParticleBackground;